import script from "./CommonTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonTable.vue?vue&type=script&lang=ts&setup=true"

import "./CommonTable.vue?vue&type=style&index=0&id=79999475&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79999475"]])

export default __exports__